import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d65digadtlshu6s4gdkg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="py-16 px-6 bg-[#2C2C2C]">
      <div className="max-w-6xl mx-auto">
        {/* 上部エリア */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12 pb-12 border-b border-white/10">
          {/* ブランドエリア */}
          <div className="md:col-span-5">
            <Link to="/" className="inline-block mb-5">
              <img
                src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/a6432ee4b37c265c1d5171353c491488.png"
                alt="Atelier Folio"
                className="h-9 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-sm text-white/60 leading-relaxed mb-6 max-w-sm">
              描く人のために設計された、唯一のモバイルiPadケーススタンド。
              医学的に推奨される角度設計で、あなたの創作を支えます。
            </p>
            
            {/* ニュースレター */}
            <div>
              <p className="text-sm text-white/80 mb-3 font-medium">最新情報を受け取る</p>
              <form onSubmit={handleNewsletterSubmit} data-readdy-form className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="メールアドレス"
                  className="flex-1 bg-white/10 border border-white/20 rounded-full py-2 px-4 text-white placeholder-white/40 focus:outline-none focus:border-[#8B6BAE] transition-colors text-sm"
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="px-5 py-2 bg-[#8B6BAE] text-white text-sm rounded-full hover:bg-[#7A5C9E] transition-colors disabled:opacity-50 whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? '...' : '登録'}
                </button>
              </form>
              {submitStatus === 'success' && (
                <p className="text-xs text-[#8B6BAE] mt-2">登録が完了しました！</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-xs text-[#E8B4B8] mt-2">エラーが発生しました。</p>
              )}
            </div>
          </div>

          {/* ナビゲーション */}
          <div className="md:col-span-3">
            <h4 className="text-sm text-[#8B6BAE] mb-4 font-medium uppercase tracking-wider">製品情報</h4>
            <ul className="space-y-3">
              <li>
                <a href="#features" className="text-white/60 hover:text-white transition-colors text-sm cursor-pointer">
                  特徴
                </a>
              </li>
              <li>
                <a href="#angle" className="text-white/60 hover:text-white transition-colors text-sm cursor-pointer">
                  角度設計
                </a>
              </li>
              <li>
                <a href="#material" className="text-white/60 hover:text-white transition-colors text-sm cursor-pointer">
                  素材
                </a>
              </li>
              <li>
                <a href="#cta" className="text-white/60 hover:text-white transition-colors text-sm cursor-pointer">
                  購入
                </a>
              </li>
            </ul>
          </div>

          {/* 連絡先 */}
          <div className="md:col-span-4">
            <h4 className="text-sm text-[#8B6BAE] mb-4 font-medium uppercase tracking-wider">お問い合わせ</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-2.5">
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-white/10">
                  <i className="ri-mail-line text-sm text-[#8B6BAE]"></i>
                </div>
                <span className="text-sm text-white/60">info@mever.design</span>
              </div>
              <div className="flex items-start gap-2.5">
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-white/10 shrink-0">
                  <i className="ri-map-pin-line text-sm text-[#8B6BAE]"></i>
                </div>
                <span className="text-sm text-white/60 leading-relaxed">
                  〒100-6213 東京都千代田区丸の内1-11-1
                  <br />
                  パシフィックセンチュリープレイス丸の内13F
                </span>
              </div>
            </div>

            {/* SNS */}
            <div className="mt-6">
              <p className="text-sm text-white/40 mb-3">Follow Us</p>
              <div className="flex items-center gap-2">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white/60 hover:bg-[#8B6BAE] hover:text-white transition-all cursor-pointer">
                  <i className="ri-instagram-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white/60 hover:bg-[#8B6BAE] hover:text-white transition-all cursor-pointer">
                  <i className="ri-twitter-x-line text-base"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white/60 hover:bg-[#8B6BAE] hover:text-white transition-all cursor-pointer">
                  <i className="ri-facebook-fill text-base"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* 下部エリア */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-5">
          <p className="text-sm text-white/40">&copy; 2025 Atelier Folio. All rights reserved.</p>
          
          <div className="flex items-center gap-5">
            <a href="#" className="text-white/40 hover:text-white/60 transition-colors text-sm cursor-pointer">
              プライバシーポリシー
            </a>
            <a href="#" className="text-white/40 hover:text-white/60 transition-colors text-sm cursor-pointer">
              利用規約
            </a>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-white/30 hover:text-white/50 transition-colors text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
